import type { IsActivedValue, Visibility } from '@space-core/datahub'
import { ComponentNames } from '@space-core/datahub'
import { BaseTrySchema } from '@space-core/datahub/hotmartClub'
import type { DeviceInfoProps } from '@space-core/hooks/useDeviceInfo'

export default class TryToCreateCommunitySchema extends BaseTrySchema {
  action: string
  role: string
  communityId: number
  communityType: string
  communityName?: string
  restrictedPosts: IsActivedValue
  restrictedComments: IsActivedValue
  communityPostModeration: IsActivedValue
  visibility: Visibility
  deviceInfo: DeviceInfoProps

  constructor({
    communityId = 0,
    communityType,
    communityName,
    userRole,
    restrictedPosts,
    restrictedComments,
    visibility,
    communityPostModeration,
    result,
    statusCode,
    failureDescription,
    componentSource,
    deviceInfo
  }) {
    super({
      result: result,
      statusCode: statusCode,
      componentName: ComponentNames.COMMUNITY_CREATION_MODAL,
      componentSource: componentSource,
      failureDescription: failureDescription
    })
    this.action = 'try_to_create_a_community'
    this.role = userRole
    this.communityId = communityId
    this.communityName = communityName
    this.communityType = communityType
    this.restrictedPosts = restrictedPosts
    this.restrictedComments = restrictedComments
    this.communityPostModeration = communityPostModeration
    this.visibility = visibility
    this.deviceInfo = deviceInfo
  }

  getDataHubEventData() {
    return {
      ...super.prepare(),
      hasAccessToTheCommunity: true,
      userRole: this.role,
      communityId: this.communityId,
      communityType: this.communityType,
      restrictedPosts: this.restrictedPosts,
      restrictedComments: this.restrictedComments,
      visibility: this.visibility,
      communityPostModeration: this.communityPostModeration,
      communityName: this.communityName,
      ...this.deviceInfo
    }
  }
}
